import { render, staticRenderFns } from "./RedPacketCreatePane.vue?vue&type=template&id=5973a297&scoped=true"
import script from "./RedPacketCreatePane.vue?vue&type=script&lang=js"
export * from "./RedPacketCreatePane.vue?vue&type=script&lang=js"
import style0 from "./RedPacketCreatePane.vue?vue&type=style&index=0&id=5973a297&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973a297",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5973a297')) {
      api.createRecord('5973a297', component.options)
    } else {
      api.reload('5973a297', component.options)
    }
    module.hot.accept("./RedPacketCreatePane.vue?vue&type=template&id=5973a297&scoped=true", function () {
      api.rerender('5973a297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/red_packet/components/RedPacketCreatePane.vue"
export default component.exports